<template>
  <!-- This example requires Tailwind CSS v2.0+ -->
  <nav class="bg-white shadow">
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
      <div class="flex justify-between h-16">
        <div class="flex">
          <div class="flex-shrink-0 flex items-center">
            <router-link to="/home">
              <img
                class="h-8 w-auto"
                src="../../assets/eucerin-logo.png"
                alt="Eucerin logo"
              />
            </router-link>
          </div>
          <div class="hidden sm:ml-6 sm:flex sm:space-x-8">
            <!-- Current: "border-indigo-500 text-gray-900", Default: "border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700" -->
            <router-link
              to="/home"
              :class="
                currentRouteName === 'home' ? desktop.current : desktop.default
              "
            >
              Naslovna strana
            </router-link>
            <router-link
              to="/promotion"
              :class="
                currentRouteName === 'promotion'
                  ? desktop.current
                  : desktop.default
              "
              v-if="promotion.activePromotion"
            >
              Promocija u toku
            </router-link>
            <router-link
              to="/promotion/new-promotion"
              :class="
                currentRouteName === 'promotion'
                  ? desktop.current
                  : desktop.default
              "
              v-else
            >
              Promocija
            </router-link>
            <router-link
              to="/calendar"
              :class="
                currentRouteName === 'calendar'
                  ? desktop.current
                  : desktop.default
              "
            >
              Kalendar promocija
            </router-link>
            <router-link
              to="/education"
              :class="
                currentRouteName === 'education'
                  ? desktop.current
                  : desktop.default
              "
            >
              Edukacija
            </router-link>
            <router-link
              to="/profile"
              :class="
                currentRouteName === 'profile'
                  ? desktop.current
                  : desktop.default
              "
            >
              Korisnički profil
            </router-link>
          </div>
        </div>
        <div class="hidden sm:ml-6 sm:flex sm:items-center">
          <a
            href="#"
            class="float-right border-transparent text-gray-500 hover:border-gray-300 hover:text-gray-700 inline-flex items-center px-1 pt-1 border-b-2 text-sm font-medium"
            @click="logout"
          >
            Odjavi se
          </a>
        </div>
        <div class="-mr-2 flex items-center sm:hidden">
          <!-- Mobile menu button -->
          <button
            @click="menuOpened = !menuOpened"
            type="button"
            class="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-indigo-500"
            aria-controls="mobile-menu"
            aria-expanded="false"
          >
            <span class="sr-only">Open main menu</span>
            <!-- Icon when menu is closed. -->
            <!--
              Heroicon name: outline/menu

              Menu open: "hidden", Menu closed: "block"
            -->
            <svg
              :class="menuOpened ? 'hidden' : 'block'"
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
            <!-- Icon when menu is open. -->
            <!--
              Heroicon name: outline/x

              Menu open: "block", Menu closed: "hidden"
            -->
            <svg
              :class="menuOpened ? 'block' : 'hidden'"
              class="h-6 w-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
              aria-hidden="true"
            >
              <path
                stroke-linecap="round"
                stroke-linejoin="round"
                stroke-width="2"
                d="M6 18L18 6M6 6l12 12"
              />
            </svg>
          </button>
        </div>
      </div>
    </div>

    <!-- Mobile menu, show/hide based on menu state. -->
    <div
      :class="menuOpened ? 'block' : 'hidden'"
      class="sm:hidden"
      id="mobile-menu"
    >
      <div class="pt-2 pb-3 space-y-1">
        <!-- Current: "bg-indigo-50 border-indigo-500 text-indigo-700", Default: "border-transparent text-gray-500 hover:bg-gray-50 hover:border-gray-300 hover:text-gray-700" -->
        <router-link
          to="/home"
          :class="currentRouteName === 'home' ? mobile.current : mobile.default"
          >Naslovna strana</router-link
        >
        <router-link
          to="/promotion"
          :class="
            currentRouteName === 'promotion' ? mobile.current : mobile.default
          "
          >Promocija</router-link
        >
        <router-link
          to="/calendar"
          :class="
            currentRouteName === 'calendar' ? mobile.current : mobile.default
          "
          >Kalendar promocija</router-link
        >
        <router-link
          to="/education"
          :class="
            currentRouteName === 'education' ? mobile.current : mobile.default
          "
        >
          Edukacija
        </router-link>
        <router-link
          to="/profile"
          :class="
            currentRouteName === 'profile' ? mobile.current : mobile.default
          "
          >Korisnički profil</router-link
        >
        <a
          href="#"
          :class="currentRouteName === '' ? mobile.current : mobile.default"
          @click="logout"
        >
          Odjavi se
        </a>
      </div>
    </div>
  </nav>
</template>

<script>
import Navigation from "./Navigation";
export default Navigation;
</script>
